module.exports = __webpack_public_path__ + "static/media/Phanpy_gaussian2.d89f9ec4.png";